import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import defineTemas from './defineTemas';
import definicoescliente from './definicoes-cliente.json';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);

document.documentElement.setAttribute('data-btn-variant', 'filled');

defineTemas([
  definicoescliente.Temas.TemaPrimario, 
  definicoescliente.Temas.TemaSecundario,
  definicoescliente.Temas.TemaSecundarioClaro,  
  definicoescliente.Temas.TemaPrimarioClaro,
]);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch((error) => {
        console.log('ServiceWorker registration failed: ', error);
      });
  });
}
